export enum ECurrentOrderBlock {
    orders = 0,
    archive = 1,
    favorite = 2,
    history = 3,
    location = 4,
}
